export const CUSTOMER_SCORE_MOCK = {
  SCORE_APPROVED: {
    score: '8000.00',
    others: {
      month_3: '2666.66',
      month_6: '1333.33',
      month_12: '666.66',
    },
  },
  SCORE_NULL: {
    score: null,
    others: null,
  },
  SCORE_REJECTED: {
    score: '0.0',
    others: {
      month_3: '0.00',
      month_6: '0.00',
      month_12: '0.00',
    },
  },
};
